/* eslint-disable no-unused-vars */
import React from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
} from "@mui/material";
import globalColors from "../../../../../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { ReactComponent as IconCircleLeft } from "../../../../../../../../assets/icons/akar-icons_circle_dark.svg";
import { ReactComponent as IconCircleRight } from "../../../../../../../../assets/icons/icon_circle-chevron-right-fill.svg";

export const ConfirmModal = (props) => {
  return (
    <>
      <Modal
        open={props.open}
        onClose={() => props.handleOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        disableEnforceFocus // não fecha quando perde o foco
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 999,
          }}
        >
          <Box
            sx={{
              width: "445px",
              height: "260px",
              backgroundColor: globalColors.colorWhite,
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography
              id="modal-modal-title"
              style={{
                textAlign: "center",
                color: globalColors.primaryColor1,
                marginTop: "20px",
              }}
              variant="h1"
              fontSize="24px"
              fontWeight="bold"
            >
              Deletar Parametrização
            </Typography>
            <Typography
              id="modal-modal-description"
              style={{
                color: globalColors.textColor2,
                fontSize: "16px",
                textAlign: "center",
                marginTop: "24px",
              }}
            >
              <span>Deseja deletar essa parametrização? </span>
              <br />
              <span
                fontWeight="bold"
                style={{
                  color: globalColors.alertColor,
                }}
              >
                <b>Atenção: </b>
              </span>
              essa ação não poderá ser desfeita.
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginTop: "24px",
                boxShadow: "none",
              }}
            >
              <Button
                variant="secondary"
                color={globalColors.primaryColor2}
                type="button"
                onClick={() => {
                  props.setId(null);
                  props.handleOpen(false);
                }}
                style={{
                  boxShadow: "none",
                  display: "flex",
                  alignItems: "center",
                  color: globalColors.primaryColor1,
                }}
              >
                <IconCircleLeft />
                <Typography
                  fontWeight="bold"
                  style={{
                    marginLeft: "5px",
                    textDecoration: "underline",
                    color: globalColors.primaryColor1,
                  }}
                >
                  {" "}
                  Cancelar
                </Typography>
              </Button>
              <Button
                variant="primary"
                type="submit"
                style={{
                  backgroundColor: globalColors.primaryColor1,
                  boxShadow: "none",
                  alignItems: "center",
                  color: globalColors.textColor1,
                  width: "150px",
                  height: "48px",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  props.handleOpen(false);
                  props.setConfirmedDelete(true);
                }}
                title={"deletar"}
                submitText={props.submitText}
              >
                <span className="text-light">
                  {props.submitText ?? "Confirmar"} <IconCircleRight />
                </span>
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ConfirmModal;
